module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/01-3870dfa948f338902745986b9fe1d44d.jpg";